import {
  fmtBingxSymbol,
  mapIntervalToBingx,
  normalizeCandleFromArray,
  decodeWsMessage,
  extractWsKline,
  randomId,
} from "./bingx/utils";

// Прямой REST-хост
const API_HOST = "https://open-api.bingx.com";
// Локальный прокси (как у gate/mexc) — чтобы не ловить CORS
const PROXY = `${process.env.REACT_APP_BACKEND_URL}/proxy`;
// WS для СПОТ kline
const WS_URL = "wss://open-api-ws.bingx.com/market";

function viaProxy(absUrl) { return `${PROXY}/${encodeURI(absUrl)}`; }

/** REST: история свечей СПОТ BingX */
export async function bingxSpotFetchHistory({
  symbol,
  interval = "1m",
  limit = 300,
  startTime,
  endTime,
}) {
  const sym = fmtBingxSymbol(symbol);          // "ETH-USDT"
  const tf  = mapIntervalToBingx(interval);    // "1m" | "5m" | ...

  const qs = new URLSearchParams();
  qs.set("symbol", sym);
  qs.set("interval", tf);
  if (limit)     qs.set("limit", String(limit));
  if (startTime) qs.set("startTime", String(startTime));
  if (endTime)   qs.set("endTime", String(endTime));

  const abs = `${API_HOST}/openApi/spot/v2/market/kline?${qs.toString()}`;
  const url = viaProxy(abs);

  console.log("[bingxSpot REST] fetch", { symbol: sym, interval: tf, limit, url });

  // const r = await fetch(url);
  const r = await fetch(url, {
    headers: {
      'ngrok-skip-browser-warning': 'true',
    },
  });
  if (!r.ok) throw new Error(`BingX SPOT REST HTTP ${r.status}`);
  const json = await r.json();

  const rows = Array.isArray(json?.data) ? json.data : [];
  // формат: [openTime, open, high, low, close, volume, closeTime]
  const out  = rows.map(normalizeCandleFromArray).filter(Boolean)
                   .sort((a,b)=>a.time-b.time);

  console.log("[bingxSpot REST] done", {
    symbol: sym, interval: tf, count: out.length,
    first: out[0], last: out[out.length - 1],
  });

  return out;
}

/** WS: подписка на kline СПОТ BingX */
export function bingxSpotOpenWS({ symbol, interval = "1m", onCandle }) {
  const sym = fmtBingxSymbol(symbol);
  const tf  = mapIntervalToBingx(interval);
  const ws  = new WebSocket(WS_URL);

  ws.onopen = () => {
    const sub = { id: randomId(), reqType: "sub", dataType: `${sym}@kline_${tf}` };
    try { ws.send(JSON.stringify(sub)); } catch {}
  };

  ws.onmessage = async (evt) => {
    const msg = await decodeWsMessage(evt);
    if (process.env.NODE_ENV !== "production") {
    }

    if (!msg) return;
    if (msg === "Ping" || msg?.ping) { try { ws.send("Pong"); } catch {} return; }

    const ext = extractWsKline(msg);
    if (!ext) return;

    if (Array.isArray(ext.candles) && ext.candles.length) {
      for (const c of ext.candles) { try { onCandle?.(c); } catch {} }
    } else if (ext.candle) {
      try { onCandle?.(ext.candle); } catch {}
    }
  };

  ws.onerror = (e) => { console.warn("[bingxSpot WS] error", e); };

  return () => { try { ws.close(1000, "bingxSpot ws close"); } catch {} };
}
